export function getDecimalSeparator(locale: string): string {
	return new Intl.NumberFormat(locale, { minimumFractionDigits: 2 })
		.formatToParts(100000) // number doesn't matter here
		.filter(({ type }) => type === 'decimal')[0]?.value;
}
